// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__183wg","icon":"home_icon__1S9Ws","btn":"home_btn__169Uj"};